import en from './payOverTimeStrings.en';

export default {
  en,
};
